<template>
  <div id="login">

    <md-card style="max-width: 500px; margin: auto;" >
      <md-card-media>
        <img src="../assets/logo.png">
      </md-card-media>
      <md-card-header>
        <div class="md-title">Scheduling System</div>
      </md-card-header>

      <form @submit.prevent="attemptLogin">
        <md-card-content>
          <md-field>
            <label>Username</label>
            <md-input v-focus v-model="username" v-bind:disabled="attemptingLogin" ></md-input>
          </md-field>
          <md-field>
            <label>Password</label>
            <md-input v-model="password" v-bind:disabled="attemptingLogin" type="password"></md-input>
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="right" >
          <md-button class="md-raised md-primary" v-bind:disabled="attemptingLogin" type="submit">Login</md-button>
        </md-card-actions>
      </form>
    </md-card>
  </div>
</template>

<script>
  export default {
    components: {},
    name: 'Login',
    data () {
      return {
        attemptingLogin: false,
        username: '',
        password: ''
      }
    },
    methods: {
      attemptLogin: function () {
        this.attemptingLogin = true
        // this.$store.dispatch('attemptLogin', {username: this.username, password: this.password})
        this.$store.attemptLogin(this.username, this.password, () => {
          this.attemptingLogin = false
        });
      }
    }
  }
</script>

<style scoped>
  #login {
    padding-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue